import { StyledSnackbarProps } from '../CustomUIElements/StyledSnackbar';
import { serialize } from 'object-to-formdata';

export const handleAPIRequest = async ({
  url,
  method,
  body,
  onSuccess,
  onFailure,
  onFinally,
  setLoaderState,
  setSnackbarState,
  successMessage,
  failureMessage,
  isFormData = false
}: {
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  body?: any;
  onSuccess?: (data: any) => void;
  onFailure?: (error: any) => void;
  onFinally?: () => void;
  setLoaderState?: (state: boolean) => void;
  setSnackbarState?: StyledSnackbarProps['setSnackbarState'];
  successMessage?: { show: boolean; message?: string };
  failureMessage?: { show: boolean; message?: string };
  isFormData?: boolean;
}) => {
  setLoaderState && setLoaderState(true);
  try {
    const response = await fetch(url, {
      method: method,
      ...(!isFormData && {
        headers: {
          'Content-Type': 'application/json'
        }
      }),
      ...(body && (isFormData ? { body: serialize(body) } : { body: JSON.stringify(body) }))
    });
    const data = await response.json();
    if (response.ok) {
      onSuccess && onSuccess(data);
      if (setSnackbarState && (successMessage !== undefined ? successMessage.show : true)) {
        setSnackbarState({
          message: successMessage?.message || data.message || 'Success',
          state: 'success'
        });
      }
    } else {
      throw data;
    }
  } catch (error) {
    if (setSnackbarState && (failureMessage !== undefined ? failureMessage.show : true)) {
      setSnackbarState({
        message:
          failureMessage?.message ||
          error.message ||
          error.errors ||
          'Something went wrong, please try again',
        state: 'error'
      });
    }
    onFailure && onFailure(error);
  } finally {
    setLoaderState && setLoaderState(false);
    onFinally && onFinally();
  }
};
